import { render } from "./FormularioDinamico.vue?vue&type=template&id=feca6952&scoped=true"
import script from "./FormularioDinamico.vue?vue&type=script&lang=js"
export * from "./FormularioDinamico.vue?vue&type=script&lang=js"

import "./FormularioDinamico.vue?vue&type=style&index=0&id=feca6952&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feca6952"]])

export default __exports__